import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../assets/css/skDatePicker.css";

const pad = (n) => String(n).padStart(2, "0");

// "YYYY-MM-DD" | Date | "" -> Date | null
const toDate = (v) => {
  if (!v) return null;
  if (v instanceof Date) return Number.isNaN(v.getTime()) ? null : v;
  // Parse as local midnight so the calendar never shifts a day by timezone.
  const iso = String(v).slice(0, 10);
  const d = new Date(`${iso}T00:00:00`);
  return Number.isNaN(d.getTime()) ? null : d;
};

// Date -> "YYYY-MM-DD" (what the forms and APIs already use)
const toISO = (d) =>
  d instanceof Date && !Number.isNaN(d.getTime())
    ? `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
    : "";

/**
 * Modern date field — drop-in replacement for <input type="date">.
 *
 * Speaks plain "YYYY-MM-DD" strings in and out, so it swaps in without changing
 * the surrounding form state. The calendar renders in a portal so it is never
 * clipped by a modal's `overflow: hidden`.
 *
 * Props:
 *   value      : "YYYY-MM-DD" | Date | ""
 *   onChange   : (isoString) => void
 *   size?      : "sm" | "md"      — 34px filter chip | 44px form field
 *   invalid?   : boolean
 *   block?     : boolean          — full width
 *   minDate? / maxDate? : same accepted formats as `value`
 */
const SkDatePicker = ({
  value,
  onChange,
  placeholder = "dd-mm-yyyy",
  size = "sm",
  invalid = false,
  disabled = false,
  block = false,
  minDate,
  maxDate,
  ariaLabel,
}) => {
  return (
    <div
      className={`sk-date sk-date--${size}${block ? " sk-date--block" : ""}`}
    >
      <DatePicker
        selected={toDate(value)}
        onChange={(d) => onChange?.(toISO(d))}
        dateFormat="dd-MM-yyyy"
        placeholderText={placeholder}
        disabled={disabled}
        minDate={toDate(minDate)}
        maxDate={toDate(maxDate)}
        showPopperArrow={false}
        popperPlacement="bottom-start"
        portalId="sk-date-portal"
        calendarClassName="sk-cal"
        wrapperClassName="sk-date__wrapper"
        className={`sk-date__input${invalid ? " is-invalid" : ""}`}
        ariaLabelledBy={ariaLabel}
        isClearable={false}
      />
      <i className="bi bi-calendar-event sk-date__icon" aria-hidden="true" />
    </div>
  );
};

export default SkDatePicker;
